import type { ComponentProps } from 'react'

import { TableHeadContext } from './table-context'

export const Head = (props: ComponentProps<'thead'>) => (
  <TableHeadContext value>
    <thead {...props} />
  </TableHeadContext>
)
